import { PiMicrophone, PiCamera, PiPencilSimple } from 'react-icons/pi'
import { WizardMode } from './wizardSteps'

/**
 * Step 0: how to start. Tapping a card selects it (highlight); the wizard's
 * footer "Next" commits the choice. No "Step X of Y".
 */
export default function ChooserStepBody({
  selectedMode,
  onSelect,
}: {
  selectedMode?: WizardMode
  onSelect: (mode: WizardMode) => void
}) {
  const cardClass = (mode: WizardMode) =>
    `flex items-center gap-3 rounded-xl border p-4 text-left hover:bg-surface-hover ${
      selectedMode === mode ? 'border-brand ring-1 ring-brand' : 'border-line'
    }`

  return (
    <div className="flex flex-col gap-3 p-4">
      <button
        type="button"
        onClick={() => onSelect('speak')}
        className={cardClass('speak')}
      >
        <PiMicrophone className="w-7 h-7 text-brand" />
        <div>
          <div className="text-base font-medium text-fg">Speak it</div>
          <div className="text-xs text-fg-tertiary">
            Describe the contact out loud
          </div>
        </div>
      </button>
      <button
        type="button"
        onClick={() => onSelect('snap')}
        className={cardClass('snap')}
      >
        <PiCamera className="w-7 h-7 text-brand" />
        <div>
          <div className="text-base font-medium text-fg">Take a photo</div>
          <div className="text-xs text-fg-tertiary">
            Photograph a business card to prefill the form
          </div>
        </div>
      </button>
      <button
        type="button"
        onClick={() => onSelect('manual')}
        className={cardClass('manual')}
      >
        <PiPencilSimple className="w-7 h-7 text-fg-secondary" />
        <div>
          <div className="text-base font-medium text-fg">Enter manually</div>
          <div className="text-xs text-fg-tertiary">
            Type the details yourself
          </div>
        </div>
      </button>
    </div>
  )
}
